var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import '../../components/header';
import '../../components/leftMenu';
import './index.css';
import '../../../node_modules/echarts/dist/echarts.js';
import * as authorization from "../../lib/authorization";
import * as ajax from '../../app-lib/ajax_proxy';
import "../../components/tree";
import * as echarts from "echarts";
var HeaderModel = /** @class */ (function (_super) {
    __extends(HeaderModel, _super);
    function HeaderModel(root) {
        var _this = _super.call(this, '/api/first/four', root, {}) || this;
        _this.popur = ko.observable('1');
        _this.allProject = ko.observable(); //全部项目
        _this.followProject = ko.observable(); //被关注项目
        _this.nofollow = ko.observable(); //未跟进项目
        _this.watieProject = ko.observable(); //签约等待确认
        _this.signgedProject = ko.observable(); //已签约项目
        _this.abandonProject = ko.observable(); //已放弃项目
        _this.userid = ko.observable(); //当前用户id
        _this.projectInformation = ko.observable(); // 项目消息
        _this.shenheInformation = ko.observable(); // 审核消息
        /////////
        _this.projectFollow = ko.observable();
        _this.xinxichi = ko.observable();
        _this.file = ko.observable();
        _this.ribao = ko.observable();
        _this.monthSelectPlus = ko.observableArray([]);
        _this.mm = ko.observable(undefined);
        _this.departmentUrluser = ko.observable('/api/org/showdepa');
        _this.showdepalist = ko.observable(false);
        _this.depaName = ko.observable('大区范围');
        _this.depaId = ko.observable('');
        _this.areaArr = ko.observableArray([]);
        _this.dateArr = ko.observableArray([]);
        _this.numArr = ko.observableArray([]);
        _this.mm.subscribe(function () {
            // console.log(this.mm());
            _this.initLoadArea();
        });
        return _this;
    }
    ;
    HeaderModel.prototype.open = function () {
    };
    HeaderModel.prototype.Popur = function (m, e) {
        //	console.log("dddddDDDDDDD" + this.popur());
        if (this.popur() == '1') {
            this.popur('0');
        }
        else {
            this.popur('1');
        }
    };
    //录入量
    HeaderModel.prototype.luru = function () {
        var _this = this;
        //event.srcElement.classList.add("active");
        this.container.querySelector("#luru").classList.add("active");
        this.container.querySelector("#qianyue").classList.remove("active");
        this.container.querySelector("#baifang").classList.remove("active");
        this.options2.xAxis[0].data = [];
        this.options2.series[0].data = [];
        ajax.get("/api/first/inputer").then(function (d) {
            _this.options2.color[0] = '#8eb5ff';
            for (var i = 0; i < d.data[0].user.length; i++) {
                _this.options2.xAxis[0].data.push(d.data[0].user[i]);
                _this.options2.series[0].data.push(d.data[1].count[i]);
            }
            _this.mychart2 = echarts.init(_this.container.querySelector('#main2'));
            _this.mychart2.setOption(_this.options2);
        });
    };
    /// 签约量
    HeaderModel.prototype.qianyue = function () {
        var _this = this;
        this.container.querySelector("#qianyue").classList.add("active");
        this.container.querySelector("#luru").classList.remove("active");
        this.container.querySelector("#baifang").classList.remove("active");
        event.srcElement.parentElement.childNodes;
        this.options2.series[0].data = [];
        this.options2.xAxis[0].data = [];
        ajax.get("/api/first/sign").then(function (d) {
            _this.options2.color[0] = '#ce9aff';
            for (var i = 0; i < d.data[0].user.length; i++) {
                _this.options2.xAxis[0].data.push(d.data[0].user[i]);
                _this.options2.series[0].data.push(d.data[1].count[i]);
            }
            _this.mychart2 = echarts.init(_this.container.querySelector('#main2'));
            _this.mychart2.setOption(_this.options2);
        });
    };
    //拜访量
    HeaderModel.prototype.baifang = function () {
        var _this = this;
        this.container.querySelector("#baifang").classList.add("active");
        this.container.querySelector("#luru").classList.remove("active");
        this.container.querySelector("#qianyue").classList.remove("active");
        this.options2.series[0].data = [];
        this.options2.xAxis[0].data = [];
        ajax.get("/api/first/visit").then(function (d) {
            _this.options2.color[0] = '#8091ff';
            for (var i = 0; i < d.data[0].user.length; i++) {
                _this.options2.xAxis[0].data.push(d.data[0].user[i]);
                _this.options2.series[0].data.push(d.data[1].count[i]);
            }
            _this.mychart2 = echarts.init(_this.container.querySelector('#main2'));
            _this.mychart2.setOption(_this.options2);
        });
    };
    HeaderModel.prototype.duble = function () {
    };
    HeaderModel.prototype.xiala = function (e) {
        if (event.stopPropagation) {
            e.stopPropagation();
            this.showdepalist(true);
            return true;
        }
        else if (window.event) {
            window.event.cancelBubble = true;
            // e.stopPropagation();
            this.showdepalist(true);
            return true;
        }
    };
    HeaderModel.prototype.closedepalist = function (e) {
        this.showdepalist(false);
        return true;
    };
    HeaderModel.prototype.onUserOrgChange = function (data) {
        this.depaName(data.name);
        this.depaId(data.id);
        this.initLoadArea();
        this.showdepalist(false);
    };
    HeaderModel.prototype.initLoadArea = function () {
        var _this = this;
        ajax.get('/api/first/allarea', {
            month: this.mm(),
            departmentId: this.depaId()
        }).then(function (d) {
            _this.dateArr([]);
            for (var i in d.data.datelist) {
                _this.dateArr.push(d.data.datelist[i] + '日');
            }
            _this.areaArr(d.data.arealist);
            _this.numArr(d.data.numlist);
            _this.initArea(_this.dateArr(), _this.areaArr(), _this.numArr());
        });
    };
    HeaderModel.prototype.checkMonth = function (m) {
        var str = {
            1: '一月',
            2: '二月',
            3: '三月',
            4: '四月',
            5: '五月',
            6: '六月',
            7: '七月',
            8: '八月',
            9: '九月',
            10: '十月',
            11: '十一月',
            12: '十二月'
        };
        if (str[m]) {
            return str[m];
        }
    };
    HeaderModel.prototype.initMonth = function () {
        this.monthSelectPlus([]);
        var m = new Date().getMonth() + 1;
        for (var i = 1; i < m + 1; i++) {
            this.monthSelectPlus.push({
                month: i,
                text: this.checkMonth(i)
            });
        }
    };
    HeaderModel.prototype.loadArea = function () {
        var _this = this;
        return ajax.get('/api/first/allarea', {
            month: this.mm(),
            departmentId: 0,
        }).then(function (d) {
            _this.dateArr([]);
            for (var i in d.data.datelist) {
                _this.dateArr.push(d.data.datelist[i] + '日');
            }
            _this.areaArr(d.data.arealist);
            _this.numArr(d.data.numlist);
        });
    };
    HeaderModel.prototype.initArea = function (date, area, num) {
        var myChart3 = echarts.init(this.container.querySelector('#main3'));
        var option3 = {
            // title: {
            // 	text: '未来一周气温变化',
            // 	subtext: '纯属虚构'
            // },
            tooltip: {
                trigger: 'axis',
                formatter: function (params, index) {
                    //					return '{b}' + "<br/>" + '{a0}:{c0}万㎡' + "<br/>" + '{a1}:{c1}'
                    var text1;
                    //console.log(params)
                    if (params.length == 1) {
                        if (params[0].seriesName == "录入面积") {
                            text1 = params[0].axisValue + "<br>" + params[0].seriesName + params[0].value + "万㎡";
                        }
                        else {
                            text1 = params[0].axisValue + "<br>" + params[0].seriesName + params[0].value;
                        }
                    }
                    else {
                        text1 = params[0].axisValue + "<br>" + params[0].seriesName + params[0].value + "万㎡" + "<br>" + params[1].seriesName + params[1].value;
                    }
                    return text1;
                }
            },
            legend: {
                data: ['录入面积', '录入条数'],
                top: '10',
            },
            toolbox: {},
            grid: {
                top: '75',
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                splitArea: {
                    show: true
                },
                data: date,
                axisLabel: {
                    textStyle: {
                        fontSize: 14,
                        color: '#333333'
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: "#89c3f8"
                    }
                },
            },
            yAxis: [{
                    type: 'value',
                    min: 0,
                    name: "面积(万㎡)",
                    nameTextStyle: {
                        color: "#000"
                    },
                    splitNumber: 5,
                    axisLabel: {
                        formatter: '{value}',
                        textStyle: {
                            fontSize: 14,
                            color: '#333333'
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#89c3f8"
                        }
                    },
                }, {
                    type: 'value',
                    min: 0,
                    name: "录入量(条)",
                    position: 'right',
                    nameTextStyle: {
                        color: "#000"
                    },
                    splitNumber: 5,
                    axisLabel: {
                        formatter: '{value}',
                        textStyle: {
                            fontSize: 14,
                            color: '#333333'
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#89c3f8"
                        }
                    },
                }],
            series: [
                {
                    name: '录入面积',
                    type: 'line',
                    smooth: true,
                    data: area,
                    areaStyle: {
                        normal: {
                            // @ts-ignore
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(117, 132, 246, 0.6)'
                                }, {
                                    offset: 0.8,
                                    color: 'rgba(117, 132, 246, 0)'
                                }], false),
                            shadowColor: 'rgba(117, 132, 246, 0.1)',
                            shadowBlur: 10
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: 'rgb(117, 132, 246)'
                        }
                    },
                },
                {
                    name: '录入条数',
                    yAxisIndex: 1,
                    type: 'line',
                    data: num,
                    smooth: true,
                    areaStyle: {
                        normal: {
                            // @ts-ignore
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(188, 141, 238, 0.6)'
                                }, {
                                    offset: 0.8,
                                    color: 'rgba(188, 141, 238, 0)'
                                }], false),
                            shadowColor: 'rgba(0, 0, 0, 0.1)',
                            shadowBlur: 10
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: 'rgb(188, 141, 238)'
                        }
                    },
                }
            ]
        };
        myChart3.setOption(option3);
        return myChart3.resize();
    };
    HeaderModel.prototype.loadIndexPage = function () {
        /// 获取到首页的四个栏
        return ajax.get('/api/menu/indexPage', { uid: authorization.getUserId() }).then(function () { }); //权限url拦截
        if (window.localStorage.getItem('UserId') == null) {
            //location.reload();
            //	console.log("No:::::::::" + window.localStorage.getItem('UserId'));
        }
        else {
            //	console.log("HAVE:::::::::" + window.localStorage.getItem('UserId'));
        }
        //console.log(this.hm.userid())
    };
    HeaderModel.prototype.loadPrivilege = function () {
        return ajax.get('/api/user/privilegeinfo', { id: authorization.getUserId() })
            .then(function (d) {
        });
    };
    HeaderModel.prototype.loadmessage = function () {
        var _this = this;
        // console.log('asdasdads')
        return ajax.get("/api/statistics/message", { userid: authorization.getUserId(), loginTime: window.localStorage.getItem("7") })
            .then(function (d) {
            // console.log('asdasdas')
            _this.allProject(d.data.allProject); //全部项目
            //console.log(this.allProject())
            _this.followProject(d.data.followProject); //被关注项目
            //console.log(this.followProject())
            _this.nofollow(d.data.nofollow); //未跟进项目
            _this.watieProject(d.data.waitProject); //签约等待确认
            _this.signgedProject(d.data.signgedProject); //已签约项目
            //console.log(this.signgedProject())
            _this.abandonProject(d.data.abandonProject); //已放弃项目
            _this.projectInformation(d.data.noReadProject); // 未读
            //this.url = '/api/user/privilegeinfo'
            //this.data.id = window.localStorage.getItem('UserId');
        });
    };
    HeaderModel.prototype.loadAdd = function () {
        return ajax.post('/api/log/add', { userId: authorization.getUserId(), logMessage: "首页" });
    };
    HeaderModel.prototype.loadButton = function () {
        return ajax.get('/api/user/buttoninfo', { id: authorization.getUserId() })
            .then(function (d) {
            window.localStorage.setItem('fenpei', d.data.fenpei);
            window.localStorage.setItem('guanbi', d.data.guanbi);
            window.localStorage.setItem('qiangdan', d.data.qiangdan);
        });
    };
    HeaderModel.prototype.onViewModelSet = function () {
        if (this.popur() == '1') {
            this.loadmessage();
        }
        window.localStorage.setItem('popur', '0');
    };
    // loadbubble(){
    //     return ajax.get('/api/statistics/smessage',{userId:authorization.getUserId(),loginTime:window.localStorage.getItem('0')}).then((d:any)=>{
    // 		ko.postbox.publish('leftMenu_myProject',d.data.count0);
    // 		ko.postbox.publish('leftMenu_myFollowProject',d.data.count1);
    // 		ko.postbox.publish('leftMenu_noFollowNews',d.data.count2);
    // 		ko.postbox.publish('leftMenu_waitProjectNews',d.data.count3);
    // 		ko.postbox.publish('leftMenu_signgedProjectNews',d.data.count4);
    // 		ko.postbox.publish('leftMenu_abandonProjectNews',d.data.count5);
    // 		localStorage.setItem('0',new Date()["Format"]('yyyy-MM-dd hh:mm:ss'))
    //     })
    // }
    HeaderModel.prototype.loadbubble = function () {
        var _this = this;
        var arr = [];
        for (var i = 0; i < 7; i++) {
            arr.push(localStorage.getItem(i.toString()));
        }
        return ajax.post('/api/statistics/smessage', { userId: authorization.getUserId(), time: arr }).then(function (d) {
            ko.postbox.publish('leftMenu_myProject', d.data.count0);
            ko.postbox.publish('leftMenu_myFollowProject', d.data.count1);
            ko.postbox.publish('leftMenu_noFollowNews', d.data.count2);
            ko.postbox.publish('leftMenu_waitProjectNews', d.data.count3);
            ko.postbox.publish('leftMenu_signgedProjectNews', d.data.count4);
            ko.postbox.publish('leftMenu_abandonProjectNews', d.data.count5);
            ko.postbox.publish('leftMenu_auditMessage', d.data.count6);
            _this.shenheInformation(d.data.count6);
        });
    };
    HeaderModel.prototype.loadnum = function () {
        return ajax.get('/api/statistics/message', { userid: authorization.getUserId(), loginTime: localStorage.getItem('7') }).then(function (d) {
            ko.postbox.publish('leftMenu_allProject', d.data.allProject);
            ko.postbox.publish('leftMenu_followProject', d.data.followProject);
            ko.postbox.publish('leftMenu_nofollow', d.data.nofollow);
            ko.postbox.publish('leftMenu_waitProject', d.data.waitProject);
            ko.postbox.publish('leftMenu_signgedProject', d.data.signgedProject);
            ko.postbox.publish('leftMenu_abandonProject', d.data.abandonProject);
            ko.postbox.publish('leftMenu_noReadProject', d.data.noReadProject);
        });
    };
    HeaderModel.prototype.load = function () {
        var _this = this;
        // console.log('进入主页')
        this.reset();
        this.initMonth();
        return Promise.all([
            this.loadbubble(),
            this.loadArea(),
            this.loadButton(),
            this.loadAdd(),
            this.loadIndexPage(),
            this.loadData().then(function (d) {
                if (d != undefined && d.data != undefined) {
                    _this.ribao(d.data.mdailyCount);
                    _this.file(d.data.mfileCount);
                    _this.xinxichi(d.data.minformationCount);
                    _this.projectFollow(d.data.mprojectCount);
                }
                else {
                    location.reload();
                }
            }), this.loadPrivilege()
        ]).then(function () {
        });
    };
    HeaderModel.prototype.reset = function () {
        this.monthSelectPlus([]);
        this.mm(undefined);
        this.showdepalist(false);
        this.depaName('大区范围');
        this.depaId('');
        this.areaArr([]);
        this.dateArr([]);
        this.numArr([]);
        if (window.localStorage.getItem('popur') == '1') {
            this.popur(window.localStorage.getItem('popur'));
        }
        else {
            this.loadnum();
            this.popur('0');
        }
        // console.log(this.popur())
        this.userid(window.localStorage.getItem('UserId'));
    };
    return HeaderModel;
}(KnockoutModel));
var mModel = /** @class */ (function (_super) {
    __extends(mModel, _super);
    function mModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    mModel.prototype.init = function () {
        this.hm = new HeaderModel(this.container);
        //this.hm.bind();
    };
    mModel.prototype.update = function (arg) {
        //this.hm.url = '/api/user/buttoninfo'
        //this.hm.data.id = window.localStorage.getItem('UserId');
        //console.log("init---------");
        return this.hm.load();
    };
    mModel.prototype.onResume = function () {
        this.hm.initArea(this.hm.dateArr(), this.hm.areaArr(), this.hm.numArr());
    };
    mModel.prototype.onInitComplete = function () {
        var _this = this;
        var myChart = echarts.init(this.container.querySelector('#main'));
        var myChart2;
        // console.log(this.hm.popur())
        var option1 = {
            color: ['#76A5FF', '#BC8CEF', '#7584F7'],
            title: {
                text: '项目信息来源',
                x: 'center',
                textStyle: {
                    fontSize: 14,
                    fontWeight: 'normal'
                }
            },
            tooltip: {
                trigger: 'item',
                formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                icon: 'circle',
                data: ['PC端', '微信端', '移动端']
            },
            series: [
                {
                    name: '访问来源',
                    type: 'pie',
                    radius: '70%',
                    center: ['55%', '55%'],
                    data: [
                        { value: 335, name: 'PC端' },
                        { value: 310, name: '微信端' },
                        { value: 234, name: '移动端' },
                    ],
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        };
        ajax.get("/api/first/source").then(function (d) {
            option1.series[0].data[0].value = d.data[2].PC;
            option1.series[0].data[1].value = d.data[0].WeiChat;
            option1.series[0].data[2].value = d.data[1].APP;
            //console.log(this.container.querySelector('#main'));
            myChart.setOption(option1);
        });
        // 使用刚指定的配置项和数据显示图表。
        ///////2  柱状图
        this.option2 = {
            color: ['#BC8CEF'],
            title: {
                text: '员工排行榜',
                textStyle: {
                    fontSize: 14,
                    fontWeight: 'normal'
                }
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                }
            },
            legend: {},
            grid: {
                top: '35',
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data: [],
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#89c3f8"
                        }
                    },
                    axisLabel: {
                        // interval:0,
                        // rotate:40,
                        show: true,
                        interval: 0,
                        formatter: function (params) {
                            var newParamsName = "";
                            var paramsNameNumber = params.length;
                            var provideNumber = 5; //一行显示几个字
                            var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                            if (paramsNameNumber > provideNumber) {
                                for (var p = 0; p < rowNumber; p++) {
                                    var tempStr = "";
                                    var start = p * provideNumber;
                                    var end = start + provideNumber;
                                    if (p == rowNumber - 1) {
                                        tempStr = params.substring(start, paramsNameNumber);
                                    }
                                    else {
                                        tempStr = params.substring(start, end) + "\n";
                                    }
                                    newParamsName += tempStr;
                                }
                            }
                            else {
                                newParamsName = params;
                            }
                            return newParamsName;
                        },
                        textStyle: {
                            fontSize: 14,
                            color: '#333333'
                        }
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    nameTextStyle: {
                        color: "#333333",
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#89c3f8"
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            fontSize: 15,
                            color: '#333333'
                        }
                    }
                }
            ],
            series: [
                {
                    type: 'bar',
                    barWidth: '60%',
                    data: []
                }
            ]
        };
        this.hm.options2 = this.option2;
        this.hm.mychart2 = myChart2;
        ajax.get("/api/first/sign").then(function (d) {
            //console.log(d.data[0].user.length)
            for (var i = 0; i < d.data[0].user.length; i++) {
                _this.option2.xAxis[0].data.push(d.data[0].user[i]);
                _this.option2.series[0].data.push(d.data[1].count[i]);
            }
            // console.log(this.option2.xAxis[0].data)
            // console.log(this.option2.series[0].data)
            myChart2 = echarts.init(_this.container.querySelector('#main2'));
            myChart2.setOption(_this.option2);
        });
        ////// 3
        //		var option3 = {
        //			// title: {
        //			// 	text: '未来一周气温变化',
        //			// 	subtext: '纯属虚构'
        //			// },
        //			tooltip: {
        //				trigger: 'axis'
        //			},
        //			legend: {
        //				data: ['本年度绩效目标', '已完成目标'],
        //				top:'10',
        //			},
        //			toolbox: {
        //				// show: true,
        //				// feature: {
        //				// 	dataZoom: {
        //				// 		yAxisIndex: 'none'
        //				// 	},
        //				// 	dataView: { readOnly: false },
        //				// 	magicType: { type: ['line', 'bar'] },
        //				// 	restore: {},
        //				// 	saveAsImage: {}
        //				// }
        //			},
        //			grid: {
        //				top:'75',
        //			},
        //			xAxis: {
        //				type: 'category',
        //				boundaryGap: false,
        //				splitArea: {
        //		            show: true
        //		      },
        //				data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
        //				axisLabel: {
        //					textStyle: {
        //						fontSize: 14,
        //						color:'#333333'
        //					}
        //				},
        //				axisLine:{
        //						lineStyle:{
        //							color:"#89c3f8"
        //						}
        //					},
        //			},
        //			yAxis: {
        //				type: 'value',
        //				min: 0,
        //				splitNumber: 5,
        //				 
        //				axisLabel: {
        //					formatter: '{value}万㎡',
        //					textStyle: {
        //						fontSize: 14,
        //						color:'#333333'
        //					}
        //				},
        //				axisLine:{
        //						lineStyle:{
        //							color:"#89c3f8"
        //						}
        //					},
        //			},
        //			series: [
        //				{
        //					name: '本年度绩效目标',
        //					type: 'line',
        //					smooth: true,
        //					data: [1200000, 1200000, 1200000, 1200000, 1200000, 1200000, 1200000, 1200000, 1200000, 1200000, 1200000, 1200000],
        //					markPoint: {
        //						data: [
        //							{ type: 'max', name: '最大值' },
        //							{ type: 'min', name: '最小值' }
        //						]
        //					},
        //					markLine: {
        //						data: [
        //							{ type: 'average', name: '平均值' }
        //						]
        //					},
        //					areaStyle: {
        //			            normal: {
        //			            	// @ts-ignore
        //			                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        //				                    offset: 0,
        //				                    color: 'rgba(117, 132, 246, 0.6)'
        //				                }, {
        //				                    offset: 0.8,
        //				                    color: 'rgba(117, 132, 246, 0)'
        //				                }], false),
        //				                shadowColor: 'rgba(117, 132, 246, 0.1)',
        //	               				shadowBlur: 10
        //				            }
        //			        },
        //			        itemStyle: {
        //			            normal: {
        //			                color: 'rgb(117, 132, 246)'
        //			            }
        //			        },
        //				},
        //				{
        //					name: '已完成目标',
        //					type: 'line',
        //					data: [1, 6, 2, 5, 3, 2, 0],
        //					smooth: true,
        //					areaStyle: {
        //			            normal: {
        //			            	// @ts-ignore
        //			                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        //			                    offset: 0,
        //			                    color: 'rgba(188, 141, 238, 0.6)'
        //			                }, {
        //			                    offset: 0.8,
        //			                    color: 'rgba(188, 141, 238, 0)'
        //			                }], false),
        //			                shadowColor: 'rgba(0, 0, 0, 0.1)',
        //            				shadowBlur: 10
        //			            }
        //			        },
        //			        itemStyle: {
        //			            normal: {
        //			                color: 'rgb(188, 141, 238)'
        //			            }
        //			        },
        //				}
        //			]
        //		};
        //		ajax.get("/api/first/allarea").then(d => {
        //			option3.series[1].data = [];
        //			option3.series[0].data = []
        //			for (let i = 0; i < 12; i++) {
        //				option3.series[0].data.push(parseFloat((d.data[0].point[0] / 10000).toFixed(2)));
        //				option3.series[1].data.push( parseFloat((d.data[0].now[i] / 10000).toFixed(2)));
        //			}
        //			
        //			myChart3.setOption(option3);
        //			
        //		});
        this.hm.initArea(this.hm.dateArr(), this.hm.areaArr(), this.hm.numArr());
        var model = this;
        window.onresize = function () {
            myChart.resize();
            myChart2.resize();
            model.hm.initArea(model.hm.dateArr(), model.hm.areaArr(), model.hm.numArr());
        };
    };
    return mModel;
}(Page));
export default mModel;
//
//export default class MyViewModel extends Page {
//  headerComponentOptions: HeaderComponentOption
//
//  init() {
//      this.headerComponentOptions = {
//          title: "1", showBackButton: false
//      }
//      this.
//  }
//  update(arg?: PageOption) {
//      return Promise.resolve();
//  }
//  onInitComplete() {
//    
//  }
//}
